import { NgModule } from "@angular/core";
import { NgxOnlyOfficeComponent } from "./ngx-onlyoffice.component";

@NgModule({
  declarations: [NgxOnlyOfficeComponent],
  exports: [NgxOnlyOfficeComponent],
  imports: [],
})
export class NgxOnlyOfficeModule { }
